module.exports = __webpack_public_path__ + "img/104.efa4636b.jpg";